<template>
	<div>
		<el-dialog :visible.sync="dialogImage" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')">
			<a :href="config.apiurl + image" target="view_window"><img :src="config.apiurl + image" alt="" class="myimg"></a>
		</el-dialog>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/video/show' }">监控管理</el-breadcrumb-item>
						<el-breadcrumb-item>单点控制</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div>
					<el-row>
						<el-col :md="18+($store.state.video.ysyone.support_ptz==0?6:0)">
							<!-- <video id="myPlayer" class="ship" poster="" controls playsInline webkit-playsinline [autoplay]>
								<source :src="video" type="application/x-mpegURL" />
								<source :src="video"/>
							</video> -->
							<el-col :span="24">
								<el-alert title="视频可能存在延时!" type="warning" center show-icon close-text="知道了"></el-alert>
								<div id="myVideo" class="ship">
									<video id="myPlayer" :src="video" class="ship2" controls autoplay></video>
								</div>
							</el-col>
							<el-col :span="24" class="qxselect">
								<el-radio-group v-model="qx" @change="select()" :size="$store.state.width<$store.state.minwidth?'mini':''">
									<el-radio-button label="流畅线路1" v-show="$store.state.width>$store.state.minwidth"></el-radio-button>
									<el-radio-button label="流畅线路2"></el-radio-button>
									<el-radio-button label="高清线路1" v-show="$store.state.width>$store.state.minwidth"></el-radio-button>
									<el-radio-button label="高清线路2"></el-radio-button>
								</el-radio-group>
							</el-col>
						</el-col>
						<el-col :md="6" v-if="$store.state.video.ysyone.support_ptz==1">
							<div class="kongzh">
								<el-row>
									<el-col :span="24" class="borderBottom" v-show="$store.state.width>$store.state.minwidth"><h3 class="kongzh-title">云台控制</h3></el-col>
									<el-row class="kongzh-body">
										<el-col :span="24">
											<el-row>
												<el-col :span="24">
													<!-- <el-col :span="6">
														<div class="kongzh-right-title0">控制</div>
													</el-col> -->
													<el-col :span="24" class="">
														<el-row class="kongzhi-top">
															<el-col :span="24">
																<el-button :size="$store.state.width<$store.state.minwidth?'mini':'medium'" id="4" v-click="CT">左上</el-button>
																<el-button :size="$store.state.width<$store.state.minwidth?'mini':'medium'" id="0" v-click="CT">&nbsp;&nbsp;上&nbsp;</el-button>
																<el-button :size="$store.state.width<$store.state.minwidth?'mini':'medium'" id="6" v-click="CT">右上</el-button>
															</el-col>
														</el-row>
														<el-row class="kongzhi-top">
															<el-col :span="24">
																<el-button :size="$store.state.width<$store.state.minwidth?'mini':'medium'" id="2" v-click="CT">&nbsp;左&nbsp;&nbsp;</el-button>
																&nbsp;
																<el-popover placement="top" title="" width="210" trigger="hover">
																	<el-button size="mini" round @click="CTvideo(2)">向&nbsp;左</el-button>
																	<el-button size="mini" round @click="Stop(2)">停&nbsp;止</el-button>
																	<el-button size="mini" round @click="CTvideo(3)">向&nbsp;右</el-button>
																	<el-button :size="$store.state.width<$store.state.minwidth?'mini':'medium'" id="" slot="reference">自动</el-button>
																</el-popover>
																&nbsp;
																<el-button :size="$store.state.width<$store.state.minwidth?'mini':'medium'" id="3" v-click="CT">&nbsp;&nbsp;右&nbsp;</el-button>
															</el-col>
														</el-row>
														<el-row class="kongzhi-top kongzhi-bottom">
															<el-col :span="24">
																<el-button :size="$store.state.width<$store.state.minwidth?'mini':'medium'" id="5" v-click="CT">左下</el-button>
																<el-button :size="$store.state.width<$store.state.minwidth?'mini':'medium'" id="1" v-click="CT">&nbsp;&nbsp;下&nbsp;</el-button>
																<el-button :size="$store.state.width<$store.state.minwidth?'mini':'medium'" id="7" v-click="CT">右下</el-button>
															</el-col>
														</el-row>
														<!-- <div class="pan" v-move="greet"></div> -->
													</el-col>
												</el-col>
												<el-col :span="24" class="borderTop">
													<!-- <el-col :span="6">
														<div class="kongzh-right-title">大小</div>
													</el-col> -->
													<el-col :span="24" class=" kongzh-right">
														<el-button id="8" icon="el-icon-zoom-in" v-click="CT" :size="$store.state.width<$store.state.minwidth?'mini':'medium'"> 放大</el-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
														<el-button id="9" icon="el-icon-zoom-out" v-click="CT" :size="$store.state.width<$store.state.minwidth?'mini':'medium'"> 缩小</el-button>
													</el-col>
												</el-col>
												<el-col :span="24" class="borderTop">
													<!-- <el-col :span="6">
														<div class="kongzh-right-title">焦距</div>
													</el-col> -->
													<el-col :span="24" class=" kongzh-right">
														<el-button id="10" icon="my-icon-yjj" v-click="CT" :size="$store.state.width<$store.state.minwidth?'mini':'medium'"> 远焦距</el-button>
														<el-button id="11" icon="my-icon-jjj" v-click="CT" :size="$store.state.width<$store.state.minwidth?'mini':'medium'"> 近焦距</el-button>
													</el-col>
												</el-col>
												<el-col :span="24" class="borderTop">
													<!-- <el-col :span="6">
														<div class="kongzh-right-title">速度</div>
													</el-col> -->
													<el-col :span="24" class=" kongzh-right">
														速度&nbsp;
														<el-radio-group v-model="sudu" :size="$store.state.width<$store.state.minwidth?'mini':'medium'">
															<el-radio-button label="缓慢"></el-radio-button>
															<el-radio-button label="适中"></el-radio-button>
															<el-radio-button label="快速"></el-radio-button>
														</el-radio-group>
													</el-col>
												</el-col>
												<el-col :span="24" class="borderTop">
													<!-- <el-col :span="6">
														<div class="kongzh-right-title">旋转</div>
													</el-col> -->
													<el-col :span="24" class=" kongzh-right">
														<el-button id="10" icon="my-icon-fzhshx" :size="$store.state.width<$store.state.minwidth?'mini':'medium'" @click="Reversal(0)">翻转</el-button>
														<el-button id="10" :size="$store.state.width<$store.state.minwidth?'mini':'medium'" @click="Reversal(1)"><i class="my-icon-fzhzy"></i>翻转</el-button>
														<el-button id="10" icon="my-icon-fz180" :size="$store.state.width<$store.state.minwidth?'mini':'medium'" @click="Reversal(2)">180°</el-button>
													</el-col>
												</el-col>
											</el-row>
										</el-col>
									</el-row>
								</el-row>
							</div>
							<div class="kongzh">
								<el-row>
									<el-col :span="24" class="borderBottom" v-show="$store.state.width>$store.state.minwidth"><h3 class="kongzh-title">视频抓拍</h3></el-col>
									<el-row class="kongzh-body">
										<el-col :span="24" class="borderBottom">
											<el-col :span="16">
												<div class="kongzh-right-title">抓拍</div>
											</el-col>
											<el-col :span="8" class="borderLeft kongzh-right">
												<el-button id="10" icon="el-icon-camera" :size="$store.state.width<$store.state.minwidth?'mini':'medium'" @click="Pz"></el-button>
											</el-col>
										</el-col>
										<el-col :span="24" class="kongzh-right">
											<el-table :data="$store.state.video.ysyphoto" height="210" style="width: 100%" size="mini" border>
												<el-table-column label="图片" header-align="center" align="center">
													<template slot-scope="scope">
														<el-popover placement="left" width="200" trigger="hover">
															<a :href="config.apiurl + scope.row.image" target="view_window"><img :src="config.apiurl + scope.row.image" alt="" class="myimg"></a>
															<el-button type="text" :size="$store.state.width<$store.state.minwidth?'mini':'medium'" slot="reference" @click="dialogImage=true,image=scope.row.image">{{Totime(scope.row.image.split('/')[scope.row.image.split('/').length-1].split('.')[0])}}</el-button>
														</el-popover>
													</template>
												</el-table-column>
												<el-table-column label="操作" width="130" header-align="center" align="center">
													<template slot-scope="scope">
														<el-button id="10" icon="el-icon-view" size="mini" @click="dialogImage=true,image=scope.row.image"></el-button>
														<el-button id="10" icon="el-icon-delete" size="mini" @click="removeImg(scope.row.id)"></el-button>
													</template>
												</el-table-column>
											</el-table>
										</el-col>
									</el-row>
								</el-row>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				myload: true,
				video: "",
				fx: {
					fx: -1,
					time: 0
				},
				sudu: '适中',
				suduJ: {
					缓慢: 0,
					适中: 1,
					快速: 2
				},
				image: '',
				dialogImage: false,
				qx: '流畅线路1',
				qxx: {
					流畅线路1: 'rtmp',
					流畅线路2: 'liveAddress',
					高清线路1: 'rtmpHd',
					高清线路2: 'hdAddress',
				},
				downtime: 0
			}
		},
		methods:{
			greet(val){
				if(val.fx==null)
				{
					return;
				}
				if(val.fx==-1)
				{
					if(new Date().getTime()-this.fx.time>800)
					{
						this.Stop(this.fx.fx);
						this.fx.fx=val.fx;
						this.fx.time=0;
						return;
					}
					else
					{
						let my=this;
						setTimeout(function(){
							my.Stop(0);
						},800);
						this.fx.fx=val.fx;
						this.fx.time=0;
						return;
					}
				}
				if(new Date().getTime()-this.fx.time>800||this.fx.time==0)
				{
					if(val.fx!=this.fx.fx)
					{
						this.CTvideo(val.fx);
						this.fx.fx=val.fx;
						this.fx.time=new Date().getTime();
					}
				}
			},
			getVideo()
			{
				if(this.$route.query.id==null)
				{
					return;
				}
				this.$store.commit('mainload',true);
				let value={
					video_id: this.$route.query.id
				}
				this.getysyone(value)
				.then((response)=>{
					if(response.data.code==1)
					{
						this.video=this.$store.state.video.ysyone[this.qxx[this.qx]];
						this.$store.commit('mainload',false);
					}
				});
			},
			CTvideo(direction)
			{
				if(this.$route.query.id==null)
				{
					return;
				}
				let value={
					video_id: this.$route.query.id,
					direction: direction,
					speed: this.suduJ[this.sudu]
				};
				this.ptzStart(value);
			},
			Stop(fx)
			{
				if(this.$route.query.id==null)
				{
					return;
				}
				let value={
					video_id: this.$route.query.id,
					direction: fx,
					speed: this.suduJ[this.sudu]
				};
				this.ptzStop(value);
			},
			CT(val)
			{
				if(val.click=="down")
				{
					this.CTvideo(val.num);
					this.downtime=new Date().getTime();
				}
				else if(val.click=="up")
				{
					if(new Date().getTime()-this.downtime>800||this.downtime==0)
					{
						this.Stop(val.num);
						this.downtime=0;
					}
					else
					{
						let my=this;
						setTimeout(function(){
							my.Stop(val.num);
						},800);
						this.downtime=0;
					}
				}
			},
			Reversal(command)
			{
				if(this.$route.query.id==null)
				{
					return;
				}
				let value={
					video_id: this.$route.query.id,
					command: command
				}
				this.ptzMirror(value);
			},
			Pz()
			{
				if(this.$route.query.id==null)
				{
					return;
				}
				let value={
					video_id: this.$route.query.id
				}
				this.capture(value);
			},
			getImage()
			{
				if(this.$route.query.id==null)
				{
					return;
				}
				let value={
					video_id: this.$route.query.id,
					order: 'updatetime desc'
				}
				this.getysyphoto(value);
			},
			removeImg(id)
			{
				if(this.$route.query.id==null)
				{
					return;
				}
				let value={
					video_id: this.$route.query.id,
					order: 'updatetime desc',
					id: id
				}
				this.delcapture(value);
			},
			select()
			{
				this.video=this.$store.state.video.ysyone[this.qxx[this.qx]];
				//this.addVideo();
			},
			addVideo()
			{
				let video = document.createElement('video');
				video.src = this.video;
				video.controls = true;
				video.id = "myPlayer";
				video.autoplay = true;
				video.style.width = "100%";
				video.style.maxHeight = "650px";
				let oldvideo = document.getElementById("myPlayer");
				let videodiv = document.getElementById("myVideo");
				videodiv.removeChild(oldvideo);
				videodiv.appendChild(video);
				new EZUIPlayer('myPlayer');
			},
			getHeight()
			{
				if(this.$store.state.width<this.$store.state.minwidth)
				{
					this.qx="流畅线路2";
				}
			}
		},
		mounted(){ 
			this.getVideo();
			this.getImage();
		},
		updated()
		{
			this.addVideo();
		},
		created() {
			window.addEventListener('resize', this.getHeight);
			this.getHeight()
		},
		destroyed() {
			window.removeEventListener('resize', this.getHeight)
		}
	}
</script>

<style scoped>
	.pan{
		width: 150px;
		height: 150px;
		margin: auto !important;
		margin-top: 10px !important;
		margin-bottom: 10px !important;
		/* background-image: url(../../../static/image/fx/fx.png); */
		background-repeat: no-repeat;
		background-position: center top;
		background-size: 100% 100%;
		overflow: hidden;
	}
	.ship{
		margin-top: 10px;
		margin-bottom: 30px;
		max-height: 650px;
		background-color: black;
	}
	.title{
		text-align: center;
		margin-top: -10px;
	}
	.top{
		margin-top: 30px;
	}
	.kongzh{
		border: 1px solid #444444;
		border-radius:4px;
		margin: 10px;
		background-color: #ffffff;
	}
	.kongzh-title{
		text-align: center;
		padding: 5px 0;
	}
	.kongzh-right{
		padding-top: 5px;
		padding-bottom: 5px;
	}
	.kongzh-right2{
		padding-bottom: 10px;
	}
	.kongzh-body{
		text-align: center;
	}
	.kongzh-right-title{
		padding-top: 10px;
	}
	.kongzh-right-title0{
		padding-top: 50px;
	}
	.xzh{
		transform:rotate(90deg);
		-ms-transform:rotate(90deg); /* Internet Explorer */
		-moz-transform:rotate(90deg); /* Firefox */
		-webkit-transform:rotate(90deg); /* Safari 和 Chrome */
		-o-transform:rotate(90deg); /* Opera */
	}
	.myimg{
		width: 100%;
	}
	.qxselect{
		text-align: center;
	}
	.borderTop{
		border-top: 1px solid #444444;
	}
	.borderBottom{
		border-bottom: 1px solid #444444;
	}
	.borderRight{
		border-right: 1px solid #444444;
	}
	.borderLeft{
		border-left: 1px solid #444444;
	}
	/* .gund{
		overflow-y :auto;
		height: 203px;
	} */
	.zhw{
		height: 1px;
	}
	.kongzhi-top{
		margin-top: 10px;
	}
	.kongzhi-bottom{
		margin-bottom: 10px;
	}
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		
	}
</style>